import { MOCK_CAMPAIGN_PERFORMANCE_AUDIENCES } from './mockFixtures';
import { CampaignPerformanceAudiencesResponse } from './types';

export const buildMockCampaignPerformanceAudiences = (): CampaignPerformanceAudiencesResponse => MOCK_CAMPAIGN_PERFORMANCE_AUDIENCES;
